// utilities
import "./utilities/animations";

// lightbox
require('fslightbox');

// components
import "./components/legal";
import "./components/main-navigation";
import "./components/accordion";
import "./components/tabs";
// import "./components/video";
import "./components/slider";

// Before & After Gallery Slider
import "./components/bna-gallery-slider";
import "./components/bna-gallery-adult-check";

// blocks
// import "../../template-parts/blocks/video-carousel/script";
import "../../template-parts/blocks/header/script";
import "../../template-parts/blocks/hero/script";
// import "../../template-parts/blocks/wine-collection/script";
// import "../../template-parts/blocks/wine-offerings/script";
// import "../../template-parts/blocks/visit-vineyard/script";
// import "../../template-parts/blocks/best-sellers/script";
// import "../../template-parts/blocks/about/script";
// import "../../template-parts/blocks/image-grid/script";
// import "../../template-parts/blocks/timeline/script";
// import "../../template-parts/blocks/event/script";
// import "../../template-parts/blocks/weddings/script";
// import "../../template-parts/blocks/hours/script";
// import "../../template-parts/blocks/wine-club/script";
// import "../../template-parts/blocks/three-column-image/script";
// import "../../template-parts/blocks/home-wine/script";
// import "../../template-parts/blocks/home-about/script";
// import "../../template-parts/blocks/home-intro/script";
// import "../../template-parts/blocks/event-title/script";
// import "../../template-parts/blocks/event-slider/script";
// import "../../template-parts/blocks/event-reviews/script";
// import "../../template-parts/blocks/event-choose/script";
// import "../../template-parts/blocks/wedding-gallery/script";
import "../../template-parts/blocks/news-carousel/script";
import "../../template-parts/blocks/image-toggle/script";
import "../../template-parts/blocks/tabbed-content/script";
import "../../template-parts/blocks/image-slider/script";